// @ts-strict-ignore
import { AdSlotStatus } from '../../models';
import { Context, slotService } from '../../services';
import { logger, scriptLoader } from '../../utils';

const logGroup = 'nativo';
const NATIVO_LIBRARY_URL = '//s.ntv.io/serve/load.js';

export class Nativo {
	static FEED_AD_SLOT_NAME = 'ntv_feed_ad';

	private static AD_SLOT_MAP = {
		1142668: Nativo.FEED_AD_SLOT_NAME,
		1142669: Nativo.FEED_AD_SLOT_NAME,
		456441: Nativo.FEED_AD_SLOT_NAME,
	};

	constructor(protected context: Context) {}

	isEnabled() {
		const isEnabled =
			this.context.get('services.nativo.enabled') && this.context.get('wiki.opts.enableNativeAds');

		Nativo.log('Is Nativo enabled?', isEnabled);

		return isEnabled;
	}

	load() {
		Nativo.log('Loading Nativo API...');

		scriptLoader
			.loadScript(NATIVO_LIBRARY_URL, true, null, {}, { ntvSetNoAutoStart: '' })
			.then(() => {
				Nativo.log('Nativo API loaded.');
				this.watchNtvEvents();
			});
	}

	scrollTriggerCallback(slotName: string) {
		this.context.push('state.adStack', { id: slotName });
	}

	replaceAndShowSponsoredFanAd(): void {
		const nativoFeedAdSlotElement = document.getElementById(Nativo.FEED_AD_SLOT_NAME);
		const recirculationSponsoredElement = document.querySelector(
			'.recirculation-prefooter__item.is-sponsored.can-nativo-replace',
		);

		if (nativoFeedAdSlotElement && recirculationSponsoredElement) {
			recirculationSponsoredElement.replaceWith(nativoFeedAdSlotElement);
			Nativo.log('Replacing sponsored element with Nativo feed ad');
		} else {
			Nativo.log('Could not replace sponsored element with Nativo feed ad');
		}
	}

	static log(...logValues) {
		logger(logGroup, ...logValues);
	}

	private watchNtvEvents(): void {
		window.ntv.Events?.PubSub?.subscribe('noad', (e: NativoNoAdEvent) => {
			const slotName = Nativo.AD_SLOT_MAP[e.data[0].id];
			this.handleNtvNativeEvent(e, slotName, AdSlotStatus.STATUS_COLLAPSE);
		});

		window.ntv.Events?.PubSub?.subscribe('adRenderingComplete', (e: NativoCompleteEvent) => {
			const slotName = Nativo.extractSlotIdFromNativoCompleteEventData(e);
			this.handleNtvNativeEvent(e, slotName, AdSlotStatus.STATUS_SUCCESS);
		});
	}

	static extractSlotIdFromNativoNoAdEventData(e: NativoNoAdEvent): string {
		return e.data[0]?.adLocation
			? e.data[0].adLocation.substring(1)
			: Nativo.AD_SLOT_MAP[e.data[0].id];
	}

	static extractSlotIdFromNativoCompleteEventData(e: NativoCompleteEvent): string {
		return e.data.placement ? Nativo.AD_SLOT_MAP[e.data.placement] : Nativo.AD_SLOT_MAP[e.data.id];
	}

	private handleNtvNativeEvent(
		e: NativoNoAdEvent | NativoCompleteEvent,
		slotName: string,
		adStatus: string,
	) {
		Nativo.log('Nativo native event fired', e, slotName, adStatus);

		if (!slotName) return;

		const slot = slotService.get(slotName);
		Nativo.log('Handling Nativo native event', slotName, slot);

		if (!slot || slot.getSlotName() !== slotName) return;

		if (adStatus === AdSlotStatus.STATUS_COLLAPSE) {
			slot.hide();
		}

		if (adStatus === AdSlotStatus.STATUS_SUCCESS && slotName === Nativo.FEED_AD_SLOT_NAME) {
			this.replaceAndShowSponsoredFanAd();
		}

		if (slot.getStatus() !== adStatus) {
			slot.setStatus(adStatus);
		} else {
			Nativo.log('Slot status already tracked', slot.getSlotName(), adStatus);
		}
	}
}
